import "./polyfills";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { store } from "./redux/store";
import App from "./App";
import "./styles/globals.css";
import "./index.css";
// import * as Sentry from '@sentry/react';
import { H } from "highlight.run";
import { ErrorBoundary } from '@highlight-run/react';

import posthog from "posthog-js";
import { FallbackComponent } from "./components/FallbackComponent";

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: "always",
  });
  if (localStorage.getItem("phone")) {
    posthog.identify(localStorage.getItem("phone"));
  }
}

// if (import.meta.env.VITE_SENTRY_DSN) {
//   Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     // integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//     // tracesSampleRate: 0.1,
//     // tracePropagationTargets: import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS,
//     // replaysSessionSampleRate: 0.1,
//     // replaysOnErrorSampleRate: 1.0,
//     initialScope: {
//       tags: {
//         phone: localStorage.getItem('phone'),
//       },
//       user: {
//         phone: localStorage.getItem('phone'),
//       },
//     },
//   });
// }

if (import.meta.env.VITE_HIGHLIGHT_API_KEY) {
  H.init(import.meta.env.VITE_HIGHLIGHT_API_KEY, {
    serviceName: "frontend-app",
    tracingOrigins: true,
    networkRecording: {
      enabled: true,
      recordHeadersAndBody: true,
      urlBlocklist: [],
    },
  })

  H.identify(localStorage.getItem("phone"));
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 120 * 1000,
    },
  },
});

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ErrorBoundary fallback={FallbackComponent}>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((_registration) => {
        // console.log('ServiceWorker registration successful:', registration.scope);
      })
      .catch((_error) => {
        // console.log('ServiceWorker registration failed:', error);
      });
  });
}
